import type { FC } from 'react';

interface Props {
  selectedCategory: string | undefined;
  setSelectedCategory: (id: string | undefined) => void;
  categories: string[];
}

const CommunityPhotoCategoryFilter: FC<Props> = ({
  categories,
  selectedCategory,
  setSelectedCategory,
}) => {
  return (
    <div className="flex flex-wrap justify-center gap-3 mb-12">
      <button
        key="community-photo-category-all"
        onClick={() => setSelectedCategory(undefined)}
        className={`px-6 py-2 rounded-none font-medium transition-all duration-200 ${
          !selectedCategory
            ? 'bg-primary-600 text-white transform scale-105'
            : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
        }`}
      >
        All
      </button>
      {categories.map((category) => (
        <button
          key={`community-photo-category-${category}`}
          onClick={() => setSelectedCategory(category)}
          className={`px-6 py-2 rounded-none font-medium transition-all duration-200 ${
            selectedCategory === category
              ? 'bg-primary-600 text-white transform scale-105'
              : 'bg-white text-gray-700 hover:bg-gray-100 border border-gray-200'
          }`}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default CommunityPhotoCategoryFilter;
